/* eslint-disable @typescript-eslint/no-explicit-any */
import { fork, ForkEffect, SagaReturnType } from 'redux-saga/effects';
import { Task } from 'redux-saga';

export function forkTask<
  Ctx extends Record<string, any>,
  Fn extends (...args: any[]) => any,
>(
  ctxAndFnName: [Ctx, Fn],
  ...args: Parameters<Fn>
): Generator<ForkEffect<SagaReturnType<Fn>>, Task<ReturnType<Fn>>, Task>;

export function forkTask<Fn extends (...args: any[]) => any>(
  fn: Fn,
  ...args: Parameters<Fn>
): Generator<ForkEffect<SagaReturnType<Fn>>, Task<ReturnType<Fn>>, Task>;

export function* forkTask<Fn extends (...args: any[]) => any>(
  fn: Fn,
  ...args: Parameters<Fn>
): Generator<ForkEffect<SagaReturnType<Fn>>, Task<ReturnType<Fn>>, Task> {
  return yield fork(fn, ...args);
}
